import openReplay from '@shared/app/openreplay'

const ENABLE_OPENREPLAY =
  (import.meta.env.PROD && internalHost() && import.meta.env.VITE_OPENREPLAY !== 'false')

export default defineNuxtPlugin((nuxtApp) => {

  // Install the openreplay plugin
  openReplay.install(nuxtApp.vueApp)

  // Is openreplay enabled?
  if (ENABLE_OPENREPLAY || useRuntimeConfig()?.public?.openReplay?.enabled) {
    openReplay.init(/auth|graphql/)
  }
})
